import { render, staticRenderFns } from "./report-dashboard.vue?vue&type=template&id=f9bc87d0&scoped=true&"
import script from "./report-dashboard.vue?vue&type=script&lang=js&"
export * from "./report-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bc87d0",
  null
  
)

export default component.exports